<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="m126-220-46-46 300-300 160 161 298-335 42 41-340 384-160-159-254 254Z" />
  </svg>
</template>
